export class CostCenter {
}
//# sourceMappingURL=cost-center.js.map